/**
 * @file IncomingCallLayout.jsx
 * @description IncomingCallLayout component for displaying and managing incoming call layout.
 * @component IncomingCallLayout
 * @exports IncomingCallLayout - Main component for displaying and managing incoming call layout.
 */

import React from "react";
import CallsLayout from "../common/CallLayout.jsx";
import IncomingCall from "./IncomingCall.jsx";
import CustomerNotes from "../common/TabNotes.jsx";
import CustomerProfile from "../common/TabProfile.jsx";
import CustomerHistory from "../common/TabHistory.jsx";
import CustomerTexts from "../common/TabTexts.jsx";
import CustomerCallsHistory from "../common/TabCallsHistory.jsx";
import CustomerEmails from "../common/TabEmails.jsx";
import CustomerDataset from "../common/TabDataset.jsx";
import SearchCustomer from "./SearchCustomer.jsx";
import {
  INCOMING_CALLS_STRINGS,
  TAB_CONFIG,
} from "../../../common/constants/agentModule/incomingCallsConstants";
import CustomerChats from "../common/TabChats.jsx";
import SearchCustomerModel from "./SearchCustomerModel.jsx";
import SendText from "../common/SendText.jsx";
import SendEmail from "../common/SendEmail.jsx";
import AddRelatedRecord from "../common/AddRelatedRecord.jsx";

const IncomingCallLayout = () => {
  const [customerGuid, setCustomerGuid] = React.useState(null);
  const [callConnectionId, setCallConnectionId] = React.useState(null);
  const tabs = [
    {
      label: INCOMING_CALLS_STRINGS.CONVERSATION,
      value: INCOMING_CALLS_STRINGS.CONVERSATION,
      component: <div>{INCOMING_CALLS_STRINGS.CONVERSATION_DESCRIPTION}</div>,
    },
    {
      label: INCOMING_CALLS_STRINGS.PROFILE,
      value: INCOMING_CALLS_STRINGS.PROFILE,
      component: (
        <CustomerProfile
          customerguid={customerGuid}
          callConnectionId={callConnectionId}
        />
      ),
    },
    {
      label: INCOMING_CALLS_STRINGS.DATASET,
      value: INCOMING_CALLS_STRINGS.DATASET,
      component: <CustomerDataset customerguid={customerGuid} />,
    },
    {
      label: INCOMING_CALLS_STRINGS.NOTES,
      value: INCOMING_CALLS_STRINGS.NOTES,
      component: <CustomerNotes customerguid={customerGuid} />,
    },
    {
      label: INCOMING_CALLS_STRINGS.HISTORY,
      value: INCOMING_CALLS_STRINGS.HISTORY,
      component: <CustomerHistory customerguid={customerGuid} />,
    },
    {
      label: INCOMING_CALLS_STRINGS.PAYMENT,
      value: INCOMING_CALLS_STRINGS.PAYMENT,
      component: <div>{INCOMING_CALLS_STRINGS.PAYMENT}</div>,
    },
    {
      label: INCOMING_CALLS_STRINGS.CALLS,
      value: INCOMING_CALLS_STRINGS.CALLS,
      component: <CustomerCallsHistory customerguid={customerGuid} />,
    },
    {
      label: INCOMING_CALLS_STRINGS.TEXTS,
      value: INCOMING_CALLS_STRINGS.TEXTS,
      component: <CustomerTexts />,
    },
    {
      label: INCOMING_CALLS_STRINGS.EMAILS,
      value: INCOMING_CALLS_STRINGS.EMAILS,
      component: <CustomerEmails customerguid={customerGuid} />,
    },
    {
      label: INCOMING_CALLS_STRINGS.CHAT,
      value: INCOMING_CALLS_STRINGS.CHAT,
      component: <CustomerChats customerguid={customerGuid} />,
    },
  ];

  const handleGuid = (guid) => {
    if (guid) {
      setCustomerGuid(guid);
    }
  };
  const handleChannelReference = (connectionId) => {
    if (connectionId) {
      setCallConnectionId(connectionId);
    }
  };

  const menuAction = [];
  if (!customerGuid) {
    menuAction.push(
      {
        component: <SearchCustomer onCustomerGuid={handleGuid} />,
      },
      {
        component: <SendText customerguid={customerGuid} />,
      },
      {
        component: <SendEmail customerguid={customerGuid} />,
      },
      {
        component: <AddRelatedRecord customerguid={customerGuid} />,
      }
    );
  }
  // Add other menu actions as needed

  return (
    <>
      <CallsLayout
        leftPanel={
          <IncomingCall
            onCustomerGuid={handleGuid}
            onChannelReference={handleChannelReference}
          />
        }
        tabConfig={customerGuid ? tabs : null}
        // searchCustomer={
        //   !customerGuid ? <SearchCustomer onCustomerGuid={handleGuid} /> : null
        // }
        defaultTab={TAB_CONFIG.DEFAULT_TAB}
        menuActions={menuAction}
        title={INCOMING_CALLS_STRINGS.CUSTOMER_INFORMATION}
      />
      {/* {openSeachCustomer && (<SearchCustomerModel open={openSeachCustomer} onClose={()=> setopenSeachCustomer(false)} onCustomerGuid={handleGuid}></SearchCustomerModel>)} */}
    </>
  );
};

export default IncomingCallLayout;
